import React from 'react';

import { Notification } from '@savgroup-front-common/types';

interface ToastsContextValue {
  pushNotifications: (notifications: Notification[]) => void;
}

const ToastsProviderContext = React.createContext<ToastsContextValue>({
  pushNotifications: () => [],
});

export default ToastsProviderContext;
